export default __webpack_public_path__ + "static/media/concerts_bg.8981ad15.jpg";